<template>
    <fb-main-body>

    </fb-main-body>
</template>

<script>
    export default {
        name: "Home",
        components:[]
    }
</script>

<style scoped>

</style>